export enum PublicVerifierDetailsParams {
  verifierUuid = "verifierUuid",
}
